export const FIXED_OPT_CODE_VAL = "FIXED";
export const VARIABLE_OPT_CODE_VAL= "VARIABLE";
export const OPT_CODE_OPTIONS = [
    {value: FIXED_OPT_CODE_VAL, textCode: 'adjustment.optionalCode.'+FIXED_OPT_CODE_VAL},
    {value: VARIABLE_OPT_CODE_VAL, textCode: 'adjustment.optionalCode.'+VARIABLE_OPT_CODE_VAL},
];